import React from 'react';
import { HTMLOverlay } from 'react-map-gl';
import { withTheme } from 'styled-components';
import ContainerDimensions from 'react-container-dimensions';
import MapTooltips from './MapTooltips';
import MapMain from './MapMain';
import MapScatterplot from './MapScatterplotContainer';
import CensusMap from './CensusMap';
import 'mapbox-gl/dist/mapbox-gl.css';
import CircularProgress from 'material-ui/CircularProgress';

const MapPage = ({ theme, match: { params } }) => (
  <ContainerDimensions>
    {({ width, height, top: mainTop, left: mainLeft }) => (
      <MapTooltips
        containerWidth={width}
        containerHeight={height}
        censusMode={!!params.cityId}
      >
        {({
          selectedPoint,
          hoveredPoint,
          renderTooltips,
          clear,
          ...callbacks
        }) => (
          <div
            onClick={() => selectedPoint && clear()}
            onMouseLeave={() => hoveredPoint && clear()}
          >
            <CensusMap
              cityId={params.cityId}
              hoveredId={hoveredPoint && hoveredPoint.id}
              {...callbacks}
            >
              {({ getMapRef, onHover, onClick, isLoading }) => (
                <div>
                  {isLoading && <CircularProgress className="loadingIcon" />}
                  <MapMain
                    width={width}
                    height={height}
                    selectedCityId={params.cityId}
                    getRef={getMapRef}
                    onHover={onHover}
                    onClick={onClick}
                  >
                    {!params.cityId ? (
                      <HTMLOverlay
                        style={{ pointerEvents: 'auto' }}
                        redraw={({ project }) => (
                          <MapScatterplot
                            top={0}
                            left={0}
                            project={project}
                            selectedCityId={selectedPoint && selectedPoint.id}
                            hoveredCityId={hoveredPoint && hoveredPoint.id}
                            {...callbacks}
                          />
                        )}
                      />
                    ) : null}
                  </MapMain>
                </div>
              )}
            </CensusMap>
            {renderTooltips()}
          </div>
        )}
      </MapTooltips>
    )}
  </ContainerDimensions>
);

export default withTheme(MapPage);



// WEBPACK FOOTER //
// ./src/components/MapPage/MapPage.jsx